import React from 'react';
import styled, { css } from 'styled-components';

import { media } from '@/utils/mixin';
import { useTypedSelector } from '@/store/store';
import { selectDetailedCarData } from '@/store/reducers/detailed-car';

function Title() {
  const data = useTypedSelector(selectDetailedCarData);

  if (!data) {
    return null;
  }

  const {
    catalog: { brand, model },
  } = data;

  return (
    <Component>
      {brand.name} {model?.name ?? ''}
    </Component>
  );
}

export default Title;

const Component = styled.h1`
  font-weight: 700;
  font-size: 32px;
  margin: 0;
  color: ${(props) => props.theme.black};

  ${media.laptopOnly(css`
    font-size: 26px;
    line-height: 30px;
  `)}

  ${media.tabletSmall(css`
    font-size: 26px;
    line-height: 29px;
  `)}

  ${media.mobile(css`
    font-size: 16px;
    line-height: 19px;
  `)}
`;
